// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #5b9bd5 0%, #70a8d6 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Source Sans Pro',
    sans-serif;
  padding-bottom: 50px;
}

.home-navbar {
  background-color: #1a2d4a !important; /* Matching the login button color */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 20px;
}

.profile-icon-button {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.65);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.profile-icon-button i {
  font-size: 1.3rem;
  line-height: 1;
}

.profile-icon-button:hover,
.profile-icon-button:focus {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.24);
  border-color: #ffffff;
  transform: translateY(-1px);
}

.profile-page {
  padding-bottom: 4rem;
}

.profile-container {
  max-width: 980px;
}

.profile-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 18px 46px rgba(26, 45, 74, 0.18);
  overflow: hidden;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f7fbff, #dceeff);
  border-bottom: 1px solid rgba(26, 45, 74, 0.08);
}

.profile-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a2d4a, #5b9bd5);
  color: #ffffff;
  font-size: 2rem;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(26, 45, 74, 0.22);
}

.profile-kicker {
  color: #5b7598;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.profile-name {
  color: #1a2d4a;
  font-size: 2rem;
  font-weight: 800;
  margin: 0;
}

.profile-email {
  color: #5f7591;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.profile-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  background: rgba(26, 45, 74, 0.08);
}

.profile-field {
  background: #ffffff;
  padding: 1.25rem 1.5rem;
  min-width: 0;
}

.profile-field-label {
  display: block;
  color: #6b7f99;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.profile-field-value {
  display: block;
  color: #1a2d4a;
  font-size: 1rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.profile-language-section {
  padding: 1rem 1.25rem;
  background: #ffffff;
  border-top: 1px solid rgba(26, 45, 74, 0.08);
}

.profile-selection-section {
  padding: 1rem 1.25rem;
  background: #ffffff;
  border-top: 1px solid rgba(26, 45, 74, 0.08);
}

.profile-selection-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: end;
  gap: 0.75rem;
}

.profile-selection-status {
  color: #5f7591;
  font-size: 0.72rem;
  font-weight: 800;
  margin-bottom: 0.7rem;
  text-align: right;
}

.profile-selection-select {
  border: 1px solid rgba(26, 45, 74, 0.16);
  border-radius: 8px;
  color: #1a2d4a;
  font-size: 0.9rem;
  font-weight: 700;
  min-height: 42px;
}

.profile-selection-select:focus {
  border-color: #5b9bd5;
  box-shadow: 0 0 0 0.2rem rgba(91, 155, 213, 0.16);
}

.profile-selection-submit {
  border: none;
  border-radius: 999px;
  background: #1a2d4a;
  font-size: 0.88rem;
  font-weight: 800;
  min-height: 42px;
  min-width: 112px;
  padding: 0.45rem 1rem;
}

.profile-selection-submit:hover:not(:disabled),
.profile-selection-submit:focus:not(:disabled) {
  background: #0f1a2e;
  box-shadow: 0 10px 22px rgba(26, 45, 74, 0.18);
}

.profile-language-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.7rem;
}

.profile-language-title {
  color: #1a2d4a;
  font-size: 0.95rem;
  font-weight: 800;
  margin: 0;
}

.profile-language-current {
  border: 1px solid rgba(91, 155, 213, 0.35);
  border-radius: 999px;
  color: #1a2d4a;
  background: #f7fbff;
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
  padding: 0.35rem 0.55rem;
}

.profile-language-meta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;
}

.profile-language-status {
  color: #5f7591;
  font-size: 0.72rem;
  font-weight: 800;
  white-space: nowrap;
}

.profile-language-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  max-width: 450px;
}

.profile-language-option {
  border: 1px solid rgba(26, 45, 74, 0.12);
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 42px;
  padding: 0.45rem 0.55rem;
  color: #1a2d4a;
  background: #f8fafc;
  text-align: left;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.profile-language-option:hover,
.profile-language-option:focus {
  border-color: rgba(91, 155, 213, 0.55);
  background: #f0f7ff;
  box-shadow: 0 10px 22px rgba(26, 45, 74, 0.08);
}

.profile-language-option.is-selected {
  border-color: #5b9bd5;
  background: #eaf4ff;
  box-shadow: inset 0 0 0 1px rgba(91, 155, 213, 0.2);
}

.profile-language-code {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #ffffff;
  background: #1a2d4a;
  font-size: 0.68rem;
  font-weight: 900;
}

.profile-language-name {
  min-width: 0;
  font-size: 0.82rem;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.manual-page {
  padding-bottom: 4rem;
}

.manual-container {
  max-width: 1080px;
}

.manual-header {
  color: #ffffff;
  margin: 0 auto 1.5rem;
  max-width: 780px;
  text-align: center;
}

.manual-kicker {
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin-bottom: 0.45rem;
  text-transform: uppercase;
}

.manual-header h1 {
  font-size: 2.4rem;
  font-weight: 850;
  margin-bottom: 0.75rem;
}

.manual-header p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0;
}

.manual-quickstart {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1px;
  margin-bottom: 1.25rem;
  overflow: hidden;
  border-radius: 8px;
  background: rgba(26, 45, 74, 0.16);
  box-shadow: 0 18px 42px rgba(26, 45, 74, 0.18);
}

.manual-quickstart > div {
  min-width: 0;
  padding: 1.25rem;
  background: #ffffff;
}

.manual-step-number {
  display: block;
  color: #5b9bd5;
  font-size: 0.8rem;
  font-weight: 900;
  margin-bottom: 0.3rem;
}

.manual-quickstart strong {
  display: block;
  color: #1a2d4a;
  font-size: 1.05rem;
  margin-bottom: 0.3rem;
}

.manual-quickstart p {
  color: #5f7591;
  font-weight: 650;
  margin: 0;
}

.manual-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.manual-card,
.manual-support {
  border: 1px solid rgba(26, 45, 74, 0.08);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 14px 32px rgba(26, 45, 74, 0.14);
}

.manual-card {
  padding: 1.25rem;
}

.manual-card h2,
.manual-support h2 {
  color: #1a2d4a;
  font-size: 1.15rem;
  font-weight: 850;
  margin-bottom: 0.75rem;
}

.manual-card ul,
.manual-support ul {
  margin: 0;
  padding-left: 1.2rem;
}

.manual-card li,
.manual-support li {
  color: #314967;
  font-weight: 600;
  margin-bottom: 0.55rem;
}

.manual-card li:last-child,
.manual-support li:last-child {
  margin-bottom: 0;
}

.manual-support {
  display: grid;
  grid-template-columns: 0.7fr 1.3fr;
  gap: 1rem;
  margin-top: 1rem;
  padding: 1.35rem;
}

.manual-support .manual-kicker {
  color: #5b7598;
}

.manual-table-wrap {
  overflow-x: auto;
}

.manual-error-table {
  width: 100%;
  min-width: 620px;
  border-collapse: collapse;
}

.manual-error-table th,
.manual-error-table td {
  border-bottom: 1px solid rgba(26, 45, 74, 0.1);
  color: #314967;
  font-size: 0.9rem;
  padding: 0.7rem 0.65rem;
  text-align: left;
  vertical-align: top;
}

.manual-error-table th {
  color: #1a2d4a;
  font-size: 0.78rem;
  font-weight: 850;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.manual-error-table tr:last-child td {
  border-bottom: none;
}

.home-card {
  background: white;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border: none;
  height: 100%;
  transition: transform 0.3s ease;
}

.home-card:hover {
  transform: translateY(-5px);
}

.square-box {
  aspect-ratio: 1 / 1;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.square-box-wrapper {
  aspect-ratio: 1 / 1;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.square-box-wrapper .card {
  height: 100%;
  overflow: hidden;
}

.square-box-wrapper .card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 15px !important;
}

.square-box-wrapper form {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.square-box-wrapper .mb-3 {
  margin-bottom: 0.5rem !important;
}

.square-box-wrapper .form-label {
  font-size: 0.75rem !important;
  margin-bottom: 0.25rem !important;
}

.square-box-wrapper .btn {
  margin-top: auto;
}

.square-box-wrapper .flex-grow-1 {
  min-height: 0 !important;
  overflow: hidden;
}

.user-panel-grid {
  --user-panel-card-height: clamp(320px, 24vw, 360px);
  align-items: stretch;
}

.user-panel-grid > [class*="col-"] {
  display: flex;
}

.user-panel-grid .square-box,
.user-panel-grid .square-box-wrapper {
  width: 100%;
  height: var(--user-panel-card-height);
  min-height: var(--user-panel-card-height);
  aspect-ratio: auto;
  box-sizing: border-box;
  overflow: hidden;
}

.user-panel-grid .home-card {
  width: 100%;
  height: 100%;
  min-height: var(--user-panel-card-height);
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.user-panel-grid .card-body {
  min-height: 0;
}

.user-panel-grid .flex-grow-1 {
  min-height: 0 !important;
}

.reservation-card.home-card,
.control-card.home-card {
  padding: 14px;
  border-radius: 14px;
}

.reservation-card .card-body,
.control-card .card-body {
  padding: 0.55rem !important;
}

.reservation-card .card-title,
.control-card .card-title {
  margin-bottom: 0.45rem !important;
  font-size: 0.82rem !important;
  line-height: 1.15;
}

.reservation-card .mb-3,
.control-card .mb-3 {
  margin-bottom: 0.35rem !important;
}

.reservation-card .form-label,
.control-card .form-label {
  margin-bottom: 0.12rem !important;
  font-size: 0.68rem !important;
  line-height: 1.15;
}

.reservation-card .home-input,
.control-card .home-input {
  height: 30px;
  min-height: 30px;
  padding: 5px 9px;
  border-radius: 9px;
  font-size: 0.72rem;
}

.reservation-card .btn-home,
.control-card .btn-home {
  height: 31px;
  min-height: 31px;
  margin-top: auto !important;
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 0.72rem;
}

.home-title {
  color: white;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 5px;
  letter-spacing: -0.5px;
}

.home-subtitle {
  color: #f0f0f0;
  margin-bottom: 40px;
  font-size: 1.1rem;
}

.home-input {
  border: none;
  background-color: #e0e0e0;
  border-radius: 15px;
  padding: 8px 15px;
  font-size: 13px;
  color: #666;
  height: 38px;
  transition: all 0.3s ease;
}

.form-select.home-input {
  padding-right: 30px;
}

.home-input::placeholder {
  color: #999;
}

.home-input:focus {
  outline: none;
  background-color: #d0d0d0;
  box-shadow: 0 0 10px rgba(91, 155, 213, 0.3);
}

.btn-home {
  background-color: #1a2d4a;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  height: 38px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-home:hover {
  background-color: #0f1a2e;
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(26, 45, 74, 0.3);
  color: white;
}

.btn-home:active {
  transform: translateY(0);
}

.card-title {
  color: #333;
  font-weight: bold;
  font-size: 0.95rem !important;
}

.hotel-dashboard {
  display: flex;
  min-height: calc(100vh - 90px);
  align-items: flex-start;
}

.hotel-sidebar {
  width: 220px;
  background: linear-gradient(180deg, rgba(236, 245, 255, 0.97), rgba(222, 237, 252, 0.95));
  border-right: 1px solid rgba(26, 45, 74, 0.1);
  padding: 2rem 0 2.5rem;
  flex-shrink: 0;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  overflow: hidden;
  z-index: 20;
  box-shadow: 18px 0 40px rgba(26, 45, 74, 0.08);
  transition: width 0.25s ease, padding 0.25s ease;
}

.hotel-sidebar-brand {
  padding: 7.25rem 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(26, 45, 74, 0.08);
  margin-bottom: 1.5rem;
}

.hotel-sidebar-toggle {
  width: 100%;
  border: 1px solid rgba(26, 45, 74, 0.12);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin-top: 2rem;
  padding: 0.4rem 0.75rem;
  color: #1a2d4a;
  font-size: 0.78rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.72);
  transition: background 0.2s ease, border-color 0.2s ease;
}

.hotel-sidebar-toggle:hover,
.hotel-sidebar-toggle:focus {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(26, 45, 74, 0.22);
}

.hotel-sidebar-avatar {
  width: 64px;
  height: 64px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  color: #1a2d4a;
  font-size: 1.8rem;
}

.hotel-sidebar-welcome {
  color: #5f7591;
  font-size: 0.95rem;
}

.hotel-sidebar-section-title {
  background: rgba(91, 155, 213, 0.16);
  color: #1a2d4a;
  font-size: 0.9rem;
  font-weight: 700;
  padding: 0.95rem 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border-top: 1px solid rgba(26, 45, 74, 0.05);
  border-bottom: 1px solid rgba(26, 45, 74, 0.05);
}

.hotel-sidebar-nav {
  padding: 0.75rem 0;
}

.hotel-sidebar-link {
  width: 100%;
  background: transparent;
  border: none;
  border-left: 4px solid transparent;
  border-radius: 0;
  color: #3a506d;
  font-weight: 600;
  padding: 1rem 1.5rem;
  text-align: left;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.hotel-sidebar-link:hover,
.hotel-sidebar-link:focus,
.hotel-sidebar-link.is-active {
  background: linear-gradient(90deg, rgba(91, 155, 213, 0.22), rgba(255, 255, 255, 0.35));
  border-left-color: #5b9bd5;
  color: #1a2d4a;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar {
  width: 88px;
  padding-top: 1.35rem;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-brand {
  padding: 0 0.7rem 1.15rem;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-avatar {
  margin: 0 auto 0.75rem;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle {
  width: 44px;
  height: 44px;
  margin: 1rem auto 0;
  padding: 0;
  border-radius: 50%;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle span,
.hotel-dashboard.sidebar-collapsed .hotel-sidebar-section-title,
.hotel-dashboard.sidebar-collapsed .hotel-sidebar-link-label {
  display: none;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-nav {
  padding: 0.5rem 0;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.9rem 0.5rem;
}

.hotel-dashboard.sidebar-collapsed .hotel-sidebar-link i {
  margin-right: 0 !important;
}

@media (min-width: 992px) {
  body.hotel-dashboard-compact-view {
    overflow-x: hidden;
  }

  body.hotel-dashboard-compact-view .global-home-logo {
    width: min(22.4vw, 144px);
  }

  body.hotel-dashboard-compact-view.hotel-dashboard-sidebar-collapsed .global-home-logo {
    left: 8px;
    width: 54px;
  }

  body.hotel-dashboard-compact-view .home-container {
    min-width: 0;
  }

  body.hotel-dashboard-compact-view .hotel-sidebar {
    width: 176px;
    padding: 1.6rem 0 2rem;
  }

  body.hotel-dashboard-compact-view .hotel-sidebar-brand {
    padding: 6rem 1.2rem 1.4rem;
    margin-bottom: 1.2rem;
  }

  body.hotel-dashboard-compact-view .hotel-sidebar-toggle {
    margin-top: 1.6rem;
    padding: 0.32rem 0.6rem;
    font-size: 0.68rem;
  }

  body.hotel-dashboard-compact-view .hotel-sidebar-section-title {
    padding: 0.76rem 1.2rem;
    font-size: 0.72rem;
  }

  body.hotel-dashboard-compact-view .hotel-sidebar-nav {
    padding: 0.6rem 0;
  }

  body.hotel-dashboard-compact-view .hotel-sidebar-link {
    padding: 0.8rem 1.2rem;
    font-size: 0.8rem;
  }

  body.hotel-dashboard-compact-view .hotel-main {
    margin-left: 176px;
  }

  body.hotel-dashboard-compact-view .hotel-dashboard.sidebar-collapsed .hotel-sidebar {
    width: 70px;
    padding-top: 1.08rem;
  }

  body.hotel-dashboard-compact-view .hotel-dashboard.sidebar-collapsed .hotel-sidebar-brand {
    padding: 3.25rem 0.5rem 1rem;
  }

  body.hotel-dashboard-compact-view .hotel-dashboard.sidebar-collapsed .hotel-main {
    margin-left: 70px;
  }

  body.hotel-dashboard-compact-view .hotel-main-content {
    padding: 1.2rem 1.6rem;
  }

  body.hotel-dashboard-compact-view .hotel-section-shell {
    border-radius: 22px;
    padding: 1.4rem;
  }

  body.hotel-dashboard-compact-view #hotel-boxes .mb-4 {
    margin-bottom: 1.2rem !important;
  }

  body.hotel-dashboard-compact-view #hotel-boxes h3 {
    font-size: 1.35rem;
  }

  body.hotel-dashboard-compact-view #hotel-boxes p,
  body.hotel-dashboard-compact-view #hotel-boxes .btn {
    font-size: 0.8rem;
  }

  body.hotel-dashboard-compact-view .hotel-box-grid-wrap {
    --hotel-box-slot-size: 4.8rem;
  }

  body.hotel-dashboard-compact-view .hotel-box-cabinet {
    padding: 0.72rem;
    gap: 0.6rem;
  }

  body.hotel-dashboard-compact-view .hotel-box-grid {
    gap: 0.44rem;
  }

  body.hotel-dashboard-compact-view .hotel-box-slot-inner {
    padding: 0.4rem;
  }

  body.hotel-dashboard-compact-view .hotel-box-slot-label {
    font-size: 0.72rem;
  }

  body.hotel-dashboard-compact-view .hotel-box-slot-meta {
    font-size: 0.5rem;
  }

  body.hotel-dashboard-compact-view .position-value {
    font-size: 0.53rem;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-window {
    width: min(860px, calc(100vw - 24px));
    max-height: min(88vh, 760px);
  }

  body.hotel-dashboard-compact-view .hotel-switcher-list {
    padding: 1rem;
    max-height: calc(88vh - 96px);
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table-wrap {
    overflow-x: hidden;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table {
    width: 100%;
    min-width: 0;
    table-layout: fixed;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table th,
  body.hotel-dashboard-compact-view .hotel-switcher-table td {
    padding: 1.05rem 1rem;
    overflow-wrap: anywhere;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table tbody td {
    min-height: 76px;
    vertical-align: middle;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table th:nth-child(1),
  body.hotel-dashboard-compact-view .hotel-switcher-table td:nth-child(1) {
    width: 34%;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table th:nth-child(2),
  body.hotel-dashboard-compact-view .hotel-switcher-table td:nth-child(2) {
    width: 22%;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-table th:nth-child(3),
  body.hotel-dashboard-compact-view .hotel-switcher-table td:nth-child(3) {
    width: 30%;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-action-col {
    width: 14% !important;
    min-width: 96px;
    text-align: center;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-item-action {
    min-width: 78px;
    justify-content: center;
  }

  body.hotel-dashboard-compact-view .hotel-switcher-item-name,
  body.hotel-dashboard-compact-view .hotel-switcher-item-meta,
  body.hotel-dashboard-compact-view .hotel-switcher-cell-muted {
    overflow-wrap: anywhere;
  }

  body.hotel-dashboard-compact-view .hotel-components-window {
    width: min(1080px, calc(100vw - 24px));
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th,
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td {
    padding: 0.95rem 1rem;
    overflow-wrap: normal;
    word-break: normal;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(1),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(1) {
    width: 24%;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(2),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(2) {
    width: 16%;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(3),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(3) {
    width: 20%;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(4),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(4) {
    width: 14%;
    min-width: 112px;
    text-align: left;
    white-space: nowrap;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(5),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(5) {
    width: 16%;
    min-width: 128px;
    white-space: nowrap;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-action-col {
    width: 10% !important;
    min-width: 76px;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th {
    white-space: nowrap;
  }

  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(1),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(2),
  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(3) {
    overflow-wrap: anywhere;
  }
}

.hotel-sidebar-calendar-control {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(91, 155, 213, 0.25);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.75);
  color: #1a2d4a;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.hotel-sidebar-calendar-control:hover,
.hotel-sidebar-calendar-control:focus {
  background: rgba(91, 155, 213, 0.18);
  border-color: rgba(91, 155, 213, 0.45);
}

.availability-calendar-window {
  width: min(780px, calc(100vw - 16px));
  max-width: none;
  max-height: calc(100vh - 12px);
  display: flex;
  flex-direction: column;
}

.availability-calendar-window .hotel-switcher-header {
  flex: 0 0 auto;
  padding: 0.9rem 1.45rem 0.65rem;
}

.availability-calendar-window .hotel-switcher-list {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.55rem 1.45rem 0.75rem;
  overflow: hidden;
}

.availability-calendar-card {
  height: 100%;
  min-height: 0;
  padding: 0.5rem 0.75rem 0.65rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
}

.hotel-sidebar-calendar-summary {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  margin-bottom: 0.25rem;
  color: rgba(226, 232, 240, 0.82);
  font-size: 0.68rem;
  font-weight: 700;
}

.hotel-sidebar-calendar-summary span {
  color: #0f766e;
  font-size: 1.05rem;
  line-height: 1;
}

.hotel-sidebar-calendar-summary strong {
  color: #b45309;
  font-size: 1.05rem;
  line-height: 1;
}

.hotel-sidebar-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.16rem;
}

.hotel-sidebar-calendar-day {
  min-height: 50px;
  padding: 0.16rem 0.28rem;
  border: 1px solid rgba(20, 184, 166, 0.26);
  background: rgba(20, 184, 166, 0.12);
  color: rgba(226, 232, 240, 0.86);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
}

.hotel-sidebar-calendar-weekday {
  color: rgba(226, 232, 240, 0.72);
  font-size: 0.62rem;
  font-weight: 800;
  line-height: 1;
  text-align: center;
}
.calendar-day-number {
  font-size: 0.7rem;
  font-weight: 700;
  text-align: center;
  padding-bottom: 2px;
  border-bottom: 1px solid rgba(0,0,0,.08);
  line-height: 1;
}

.calendar-boxes {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 0.18rem;
  min-height: 0;
  overflow: hidden;
}

.calendar-box {
  border-radius: 4px;
  padding: 1px 3px;
  font-size: 0.52rem;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  color: white;
}

.availability-box-filter {
  margin: 0 0 0.35rem;
  display: grid;
  grid-template-columns: minmax(88px, max-content) minmax(0, 1fr) max-content;
  align-items: center;
  gap: 0.4rem;
}

.availability-box-filter-title {
  color: rgba(255,255,255,0.9);
  font-size: 0.68rem;
  font-weight: 800;
}

.availability-box-filter-list {
  max-height: 26px;
  overflow-y: auto;
  padding-right: 6px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(86px, 1fr));
  gap: 0.1rem 0.45rem;
}

.availability-box-filter-actions {
  display: flex;
  gap: 0.4rem;
  flex-wrap: nowrap;
}

.availability-box-filter-actions .btn {
  padding: 0.14rem 0.6rem;
  font-size: 0.68rem;
  line-height: 1.2;
}

@media (max-width: 720px) {
  .availability-calendar-window .hotel-switcher-header {
    padding: 1rem 1rem 0.75rem;
  }

  .availability-calendar-window .hotel-switcher-list {
    padding: 0.75rem 1rem 0.9rem;
  }

  .availability-box-filter {
    grid-template-columns: 1fr;
    align-items: stretch;
  }

  .availability-box-filter-actions {
    justify-content: flex-start;
  }

  .hotel-sidebar-calendar-day {
    min-height: 46px;
    padding-inline: 0.24rem;
  }
}

.calendar-box.available {
  background: #22c55e;
}

.calendar-box.reserved {
  background: #ef4444;
}

.calendar-box.occupied {
  background: #f59e0b;
}

.calendar-box.offline {
  background: #64748b;
}

.hotel-sidebar-calendar-day span {
  font-size: 0.95rem;
}

.hotel-sidebar-calendar-day small {
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  white-space: nowrap;
}

.calendar-count {
  display: inline-flex;
  align-items: center;
  gap: 0.08rem;
}

.calendar-count b {
  color: #475569;
  font-size: 0.54rem;
}

.hotel-sidebar-calendar-day.has-availability {
  background: rgba(20, 184, 166, 0.15);
  border-color: rgba(20, 184, 166, 0.28);
}

.hotel-sidebar-calendar-day.has-availability small {
  color: #0f766e;
}

.calendar-count.available {
  color: #0f766e;
}

.calendar-count.reserved {
  color: #b45309;
}

.hotel-sidebar-calendar-day.has-reservations {
  border-color: rgba(245, 158, 11, 0.32);
}

.hotel-sidebar-calendar-day.is-full {
  background: rgba(148, 163, 184, 0.12);
  color: #64748b;
}

.hotel-sidebar-calendar-day.is-all-reserved {
  background: rgba(245, 158, 11, 0.2);
  border-color: rgba(245, 158, 11, 0.42);
}

.hotel-sidebar-calendar-day.is-muted {
  opacity: 0.42;
}

.hotel-sidebar-calendar-day.is-today {
  box-shadow: 0 0 0 2px rgba(91, 155, 213, 0.38);
}

.hotel-sidebar-calendar-legend {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  margin-top: 0.45rem;
  color: rgba(226, 232, 240, 0.72);
  font-size: 0.58rem;
  font-weight: 700;
}

.hotel-sidebar-calendar-legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

/* Mini hotel map (in hotel overview) */
.mini-hotel-map-wrap {
  width: 100%;
  height: 100%;
  min-height: 132px;
  position: relative;
  overflow: hidden;
  border-radius: 15px;
}

.mini-hotel-map-wrap .leaflet-container {
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.10);
  background: rgba(255, 255, 255, 0.06);
}

.mini-hotel-map-empty {
  height: 100%;
  min-height: 132px;
  border-radius: 15px;
  border: 1px dashed rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.04);
  color: rgba(226, 232, 240, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.8rem;
}

@media (max-width: 991.98px) {
  .mini-hotel-map-wrap,
  .mini-hotel-map-empty {
    min-height: 150px;
  }
}


/* Day view (Google Calendar-like) */
.day-view-grid { 
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.availability-day-view {
  flex: 1 1 auto;
  min-height: 42px;
  max-height: 82px;
  margin-top: 0.4rem;
  overflow-y: auto;
  padding-right: 4px;
}

.day-view-header-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 6px;
  color: rgba(226, 232, 240, 0.78);
  font-size: 0.62rem;
  font-weight: 800;
  padding: 0 2px;
}

.day-view-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 6px;
  align-items: center;
  padding: 2px 5px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.day-view-row.is-available {
  border-color: rgba(20, 184, 166, 0.28);
}

.day-view-row.is-reserved {
  border-color: rgba(245, 158, 11, 0.32);
}

.day-view-time-col {
  color: rgba(226, 232, 240, 0.82);
  font-size: 0.6rem;
  font-weight: 900;
  white-space: nowrap;
}

.day-view-box-col {
  min-height: 20px;
}

.day-view-slot-boxes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.day-view-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 0.56rem;
  font-weight: 800;
  color: #ffffff;
  border: 1px solid rgba(255,255,255,0.35);
}

.day-view-box.available {
  box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.12) inset;
}

.day-view-box.reserved {
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.12) inset;
}

.day-view-empty {
  color: rgba(226, 232, 240, 0.55);
  font-size: 0.56rem;
  font-weight: 800;
}

.availability-day-view-empty {
  color: rgba(226, 232, 240, 0.7);
  font-size: 0.62rem;
  font-weight: 700;
  padding: 0.25rem 0;
}

.legend-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  display: inline-block;
}

.legend-dot.available {
  background: #14b8a6;
}

.legend-dot.reserved {
  background: #f59e0b;
}

.legend-dot.full {
  background: #94a3b8;
}

.box-availability-pill {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.24);
}

.box-availability-pill.is-available {
  background: rgba(20, 184, 166, 0.28);
}

.box-availability-pill.is-reserved {
  background: rgba(245, 158, 11, 0.3);
}

.box-reservation-note,
.box-upcoming-reservations {
  padding: 0.85rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(226, 232, 240, 0.86);
  font-size: 0.84rem;
}

.box-upcoming-reservation-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.75rem;
  padding: 0.42rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(226, 232, 240, 0.86);
  font-size: 0.78rem;
  font-weight: 700;
}

.box-upcoming-reservation-row:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.box-detail-window {
  width: min(860px, calc(100vw - 2rem));
  max-width: 100%;
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  border-radius: 18px;
}

.box-detail-window .hotel-switcher-header {
  flex: 0 0 auto;
}

.box-detail-window .hotel-switcher-list {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  padding: 1rem 1.25rem 1.25rem;
}

.box-detail-window .mb-4 {
  margin-bottom: 1rem !important;
}

.box-detail-window .pb-4 {
  padding-bottom: 1rem !important;
}

.box-detail-window h4 {
  font-size: 1rem;
}

.box-detail-calendar-card {
  padding: 0.75rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.box-detail-calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.8rem;
}

.box-detail-calendar-title {
  color: #f8fafc;
  font-size: 1rem;
  font-weight: 900;
}

.box-detail-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.22rem;
}

.box-detail-calendar-day {
  min-height: 54px;
  padding: 0.32rem 0.2rem;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: rgba(148, 163, 184, 0.12);
  color: rgba(226, 232, 240, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.box-detail-calendar-day span {
  font-size: 0.86rem;
  line-height: 1;
  font-weight: 900;
}

.box-detail-calendar-day small {
  font-size: 0.55rem;
  font-weight: 800;
  line-height: 1.1;
}

.box-detail-calendar-day.is-available {
  background: rgba(20, 184, 166, 0.2);
  border-color: rgba(20, 184, 166, 0.36);
  color: #ccfbf1;
}

.box-detail-calendar-day.is-reserved {
  background: rgba(245, 158, 11, 0.22);
  border-color: rgba(245, 158, 11, 0.42);
  color: #fef3c7;
}

.box-detail-calendar-day.is-muted {
  opacity: 0.42;
}

.box-detail-calendar-day.is-today {
  box-shadow: 0 0 0 2px rgba(91, 155, 213, 0.44);
}

.box-detail-calendar-day.is-selected-for-reservation {
  background: rgba(91, 155, 213, 0.34);
  border-color: rgba(191, 219, 254, 0.78);
  color: #eff6ff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);
}

.box-detail-calendar-day.is-dragging-selection {
  transform: translateY(-1px);
}

.box-detail-reserver .home-card {
  min-height: auto;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.box-detail-reserver .card-body {
  padding: 0.75rem !important;
}

.box-detail-reserver .card-title,
.box-detail-reserver .form-label {
  color: #ffffff;
}

.box-detail-reserver .card-title {
  margin-bottom: 0.6rem !important;
  font-size: 0.86rem !important;
}

.box-detail-reserver .mb-3 {
  margin-bottom: 0.45rem !important;
}

.box-detail-reserver .form-label {
  margin-bottom: 0.12rem !important;
  font-size: 0.68rem;
}

.box-detail-reserver .home-input {
  height: 31px;
  min-height: 31px;
  padding: 5px 9px;
  border-radius: 9px;
  font-size: 0.74rem;
}

.box-detail-reserver .home-input[readonly] {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  cursor: default;
}

.box-detail-reserver .btn-home {
  height: 32px;
  min-height: 32px;
  margin-top: 0.25rem !important;
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 0.74rem;
}

@media (max-width: 700px), (max-height: 760px) {
  .box-detail-backdrop {
    padding: 0.5rem;
  }

  .box-detail-window {
    width: 100%;
    max-height: calc(100vh - 1rem);
    border-radius: 14px;
  }

  .box-detail-window .hotel-switcher-header {
    padding: 0.85rem 1rem 0.65rem;
  }

  .box-detail-window .hotel-switcher-list {
    padding: 0.75rem 1rem 1rem;
  }

  .box-detail-calendar-card {
    padding: 0.6rem;
  }

  .box-detail-calendar-header {
    margin-bottom: 0.55rem;
  }

  .box-detail-calendar-day {
    min-height: 46px;
    padding: 0.24rem 0.14rem;
  }

  .box-detail-calendar-day span {
    font-size: 0.78rem;
  }

  .box-detail-calendar-day small {
    font-size: 0.48rem;
  }
}

.hotel-main {
  flex: 1 1;
  min-width: 0;
  min-height: 100vh;
  margin-left: 220px;
  transition: margin-left 0.25s ease;
}

.hotel-dashboard.sidebar-collapsed .hotel-main {
  margin-left: 88px;
}

.hotel-main-navbar {
  margin-bottom: 0;
}

.hotel-main-content {
  padding: 2rem;
}

.hotel-section-shell {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 28px;
  padding: 1.75rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
}

.hotel-overview-shell {
  --hotel-overview-gap: 1rem;
  padding: var(--hotel-overview-gap);
}

.hotel-overview-title {
  font-size: 1.35rem;
  line-height: 1.1;
}

.hotel-overview-shell .hotel-section-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(240px, 300px);
  align-items: stretch;
  gap: var(--hotel-overview-gap);
  justify-content: stretch;
  margin-bottom: var(--hotel-overview-gap);
}

.hotel-overview-shell .text-white-50 {
  font-size: 0.9rem;
}

.hotel-overview-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--hotel-overview-gap);
  margin: 0;
}

.hotel-overview-map,
.hotel-overview-stat {
  min-width: 0;
}

.hotel-overview-map {
  min-height: 132px;
}

.hotel-section-header,
.hotel-section-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.hotel-tools-shell {
  padding: 0.65rem 1.75rem 0.75rem;
}

.hotel-tools-shell .hotel-section-title-row {
  margin-bottom: 0.35rem;
}

.hotel-tools-title { 
  font-size: 1.2rem;
  line-height: 1.1;
  font-weight: 700;
}

.hotel-tools-subtitle {
  font-size: 0.9rem;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.5) !important;
}

.hotel-tools-shell .row.g-4.mb-5 {
  margin-bottom: 0 !important;
}

.hotel-tools-shell .row.g-4 {
  --bs-gutter-x: 0.5rem;
  --bs-gutter-y: 0.5rem;
}

.hotel-tools-shell .home-card {
  padding: 20px;
  border-radius: 20px;
}

.hotel-tools-shell .card-body {
  padding: 1.5rem !important;
}

.hotel-map-tooltip.leaflet-tooltip {
  background: rgba(26, 45, 74, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.24);
  color: #fff;
  padding: 0;
}

.hotel-map-tooltip.leaflet-tooltip-top:before {
  border-top-color: rgba(26, 45, 74, 0.96);
}

.hotel-map-tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 180px;
  padding: 0.75rem 0.9rem;
}

.hotel-map-tooltip-title {
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.2;
}

.hotel-map-tooltip-address {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.8rem;
  line-height: 1.35;
}

.hotel-tools-shell .card-title {
  margin-bottom: 0.15rem !important;
  font-size: 0.82rem;
}

.hotel-tools-shell p {
  margin-bottom: 0.15rem !important;
  font-size: 0.7rem;
}

.hotel-tools-shell .badge {
  padding: 0.25rem 0.4rem !important;
  font-size: 0.64rem;
}

.hotel-tools-shell .home-input {
  height: 34px;
  padding: 6px 10px;
  font-size: 0.76rem;
  border-radius: 10px;
}

.hotel-tools-shell .btn-home,
.hotel-tools-shell .btn.btn-home {
  height: 34px;
  padding: 6px 14px;
  font-size: 0.76rem;
}

.hotel-tools-shell .form-label {
  margin-bottom: 0.1rem !important;
  font-size: 0.66rem;
}

.hotel-tools-shell .mb-3 {
  margin-bottom: 0.35rem !important;
}

.hotel-tools-shell .mt-2 {
  margin-top: 0.2rem !important;
}

.hotel-tools-shell .table-responsive {
  max-height: 110px !important;
}

.hotel-tools-shell .table {
  font-size: 0.66rem;
}

.hotel-tools-shell .table th,
.hotel-tools-shell .table td {
  padding: 0.28rem 0.3rem;
}

.hotel-tools-shell .box-detail-card {
  margin-top: 0.35rem !important;
}

.hotel-tools-shell .box-detail-card .card-header {
  padding-top: 0.05rem !important;
  padding-bottom: 0.05rem !important;
}

.hotel-tools-shell .box-detail-card .list-group-item {
  padding-top: 0.15rem !important;
  padding-bottom: 0.15rem !important;
  font-size: 0.64rem;
}

.hotel-tools-reserver-wrap {
  max-width: 380px;
}

.hotel-tools-actions-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.hotel-info-badge {
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 104px;
  overflow: hidden;
}

.hotel-info-badge > .d-flex {
  min-width: 0;
  width: 100%;
}

.hotel-info-badge .text-start {
  min-width: 0;
}

.hotel-info-badge .text-nowrap {
  white-space: normal !important;
}

.weather-badge {
  max-width: none;
}

.capacity-badge {
  min-width: 0;
}

.hotel-box-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 25px;
  transition: transform 0.3s ease, background 0.3s ease;
}

.hotel-component-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.35rem;
  transition: transform 0.3s ease, background 0.3s ease;
}

.hotel-component-card:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.08);
}

.hotel-component-title {
  color: #f8fafc;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.hotel-component-meta {
  display: grid;
  gap: 0.7rem;
}

.hotel-component-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.92rem;
}

.hotel-component-label {
  color: rgba(153, 246, 228, 0.86);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.hotel-box-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(45, 212, 191, 0.18);
  color: #99f6e4;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 0.35rem 0.75rem;
  text-transform: uppercase;
}

.hotel-box-grid-wrap {
  padding: 0rem;
  border-radius: 1px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.05);
  overflow: auto;
  --hotel-box-slot-size: 6rem;
}

.hotel-box-cabinets {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 360px), 1fr));
  gap: 1rem;
}

.hotel-box-cabinet {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
  padding: 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.16);
}

.hotel-box-cabinet-title {
  color: rgba(248, 250, 252, 0.9);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.hotel-box-grid {
  display: grid;
  grid-template-columns: repeat(var(--hotel-box-grid-columns, 4), var(--hotel-box-slot-size));
  grid-auto-rows: var(--hotel-box-slot-size);
  gap: 0.55rem;
  width: max-content;
  max-width: none;
  min-width: 0;
}

.hotel-box-slot {
  width: var(--hotel-box-slot-size);
  height: var(--hotel-box-slot-size);
  aspect-ratio: 1 / 1;
  min-height: 0;
}

.hotel-box-slot-inner {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(30, 41, 59, 0.18);
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.hotel-box-slot-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1.2;
  min-width: 0;
}

.hotel-box-slot-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.16rem;
  color: #475569;
  font-size: 0.62rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.1;
  min-width: 0;
}

.hotel-box-slot-meta span,
.position-value {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hotel-box-position-info {
  width: 100%;
  margin-top: 0.25rem;
  padding-top: 0.25rem;
  border-top: 1px solid rgba(71, 85, 105, 0.2);
}

.position-value {
  color: #1e293b;
  font-size: 0.66rem;
  font-weight: 800;
}

.hotel-box-slot.is-available .hotel-box-slot-inner {
  background: linear-gradient(180deg, #ecfdf5, #d1fae5);
  border-color: rgba(5, 150, 105, 0.45);
}

.hotel-box-slot.is-reserved .hotel-box-slot-inner {
  background: linear-gradient(180deg, #eff6ff, #dbeafe);
  border-color: rgba(37, 99, 235, 0.45);
}

.hotel-box-slot.is-occupied .hotel-box-slot-inner {
  background: linear-gradient(180deg, #fff7ed, #fed7aa);
  border-color: rgba(234, 88, 12, 0.45);
}

.hotel-box-slot.is-offline .hotel-box-slot-inner {
  background: linear-gradient(180deg, #f8fafc, #e2e8f0);
  border-color: rgba(71, 85, 105, 0.5);
}

.hotel-box-slot.is-unknown .hotel-box-slot-inner {
  background: rgba(255, 255, 255, 0.92);
  border-color: rgba(30, 41, 59, 0.3);
}

@media (max-width: 576px) {
  .home-navbar .container-fluid {
    justify-content: space-between !important;
    gap: 0.75rem;
  }

  .home-navbar .navbar-brand {
    font-size: 1.05rem !important;
  }

  .home-navbar .position-absolute.end-0 {
    position: static !important;
  }

  .home-navbar .btn-outline-light {
    padding-left: 0.85rem !important;
    padding-right: 0.85rem !important;
  }

  .manual-navbar-actions,
  .profile-navbar-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .manual-header {
    text-align: left;
  }

  .manual-header h1 {
    font-size: 1.8rem;
  }

  .manual-quickstart,
  .manual-grid,
  .manual-support {
    grid-template-columns: 1fr;
  }

  .manual-card,
  .manual-support {
    padding: 1rem;
  }

  .profile-icon-button {
    width: 38px;
    height: 38px;
  }

  .profile-hero {
    align-items: flex-start;
    flex-direction: column;
    padding: 1.5rem;
  }

  .profile-avatar {
    width: 78px;
    height: 78px;
    font-size: 1.65rem;
  }

  .profile-name {
    font-size: 1.45rem;
  }

  .profile-grid {
    grid-template-columns: 1fr;
  }

  .profile-field {
    padding: 1rem 1.25rem;
  }

  .profile-selection-section,
  .profile-language-section {
    padding: 1rem;
  }

  .profile-selection-form {
    grid-template-columns: 1fr;
  }

  .profile-selection-submit {
    width: 100%;
  }

  .profile-language-header {
    align-items: flex-start;
  }

  .profile-language-options {
    grid-template-columns: 1fr;
  }

  .hotel-box-grid-wrap {
    padding: 0.75rem;
    --hotel-box-slot-size: 5.5rem;
  }

  .hotel-box-cabinets {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .hotel-box-cabinet {
    padding: 0.75rem;
  }

  .hotel-box-cabinet-title {
    font-size: 0.72rem;
  }

  .hotel-box-grid {
    width: max-content;
    max-width: none;
    min-width: 0;
    gap: 0.45rem;
  }

  .hotel-box-slot {
    width: var(--hotel-box-slot-size);
    height: var(--hotel-box-slot-size);
  }

  .hotel-box-slot-inner {
    padding: 0.45rem;
  }

  .hotel-box-slot-label {
    font-size: 0.82rem;
  }

  .hotel-box-slot-meta {
    font-size: 0.56rem;
  }

  .position-value {
    font-size: 0.58rem;
  }
}

.hotel-switcher-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(8px);
}

.hotel-switcher-window {
  width: min(680px, 100%);
  max-height: min(80vh, 720px);
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: linear-gradient(180deg, rgba(14, 25, 41, 0.96), rgba(20, 37, 61, 0.93));
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.38);
}

.hotel-switcher-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.hotel-switcher-eyebrow {
  color: rgba(153, 246, 228, 0.86);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.hotel-switcher-title {
  color: #f8fafc;
  font-size: 1.35rem;
  line-height: 1.15;
}

.hotel-switcher-list {
  padding: 1.2rem 1.5rem 1.5rem;
  max-height: calc(92vh - 112px);
  overflow-y: auto;
}

.hotel-switcher-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
}

.hotel-switcher-table {
  width: 100%;
  min-width: 640px;
  border-collapse: separate;
  border-spacing: 0;
  color: #e2e8f0;
}

.hotel-switcher-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 1rem 1.1rem;
  background: rgba(14, 25, 41, 0.98);
  color: rgba(226, 232, 240, 0.74);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.hotel-switcher-table tbody td {
  padding: 1rem 1.1rem;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.hotel-switcher-table tbody tr {
  transition: background 0.2s ease, transform 0.2s ease;
}

.hotel-switcher-table tbody tr:hover {
  background: rgba(59, 130, 246, 0.12);
}

.hotel-switcher-table tbody tr.is-current {
  background: rgba(45, 212, 191, 0.12);
}

.hotel-switcher-table tbody tr:last-child td {
  border-bottom: none;
}

.hotel-switcher-item-name {
  color: #f8fafc;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.hotel-switcher-item-meta {
  color: rgba(226, 232, 240, 0.7);
  font-size: 0.85rem;
  line-height: 1.35;
}

.hotel-switcher-cell-muted {
  color: rgba(226, 232, 240, 0.82);
  font-size: 0.85rem;
  line-height: 1.4;
}

.hotel-switcher-stat {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  border-radius: 999px;
  padding: 0.38rem 0.72rem;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(226, 232, 240, 0.9);
  font-size: 0.78rem;
  line-height: 1.2;
}

.hotel-switcher-action-col {
  width: 1%;
  white-space: nowrap;
}

.hotel-switcher-item-action {
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  padding: 0.38rem 0.8rem;
  background: rgba(255, 255, 255, 0.08);
  color: #bae6fd;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.hotel-switcher-item-action:hover,
.hotel-switcher-item-action:focus {
  background: rgba(59, 130, 246, 0.18);
  border-color: rgba(125, 211, 252, 0.45);
}

.hotel-switcher-item-action.is-current {
  background: rgba(45, 212, 191, 0.16);
  border-color: rgba(153, 246, 228, 0.3);
  color: #ccfbf1;
}

.hotel-icon-action {
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #bae6fd;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.hotel-icon-action:hover,
.hotel-icon-action:focus {
  background: rgba(59, 130, 246, 0.22);
  border-color: rgba(125, 211, 252, 0.5);
  color: #f8fafc;
}

.hotel-icon-action:disabled {
  opacity: 0.55;
  cursor: wait;
}

.hotel-switcher-action-col .hotel-icon-action {
  margin-left: 0.45rem;
}

.hotel-inline-edit-form,
.hotel-box-edit-panel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.7rem;
  align-items: center;
}

.hotel-inline-edit-input {
  min-width: 0;
  width: 100%;
  min-height: 2.35rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 0.48rem 0.65rem;
  background: rgba(15, 23, 42, 0.86);
  color: #f8fafc;
  font-size: 0.85rem;
  outline: none;
}

.hotel-inline-edit-input:focus {
  border-color: rgba(125, 211, 252, 0.62);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.16);
}

.hotel-inline-edit-input.is-wide {
  grid-column: span 2;
}

.hotel-inline-edit-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.hotel-inline-edit-message {
  grid-column: 1 / -1;
  font-size: 0.82rem;
  font-weight: 700;
}

.hotel-inline-edit-message.is-error {
  color: #fca5a5;
}

.hotel-box-edit-panel {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid rgba(125, 211, 252, 0.24);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.74);
}

.hotel-box-edit-panel-title {
  color: #f8fafc;
  font-weight: 800;
}

.hotel-switcher-empty {
  padding: 2rem 1rem;
  border-radius: 18px;
  border: 1px dashed rgba(255, 255, 255, 0.16);
  color: rgba(226, 232, 240, 0.72);
  text-align: center;
}

@media (max-width: 991.98px) {
  .hotel-dashboard {
    flex-direction: column;
  }

  .hotel-sidebar {
    position: static;
    left: auto;
    top: auto;
    bottom: auto;
    height: auto;
    overflow: visible;
    width: 100%;
    padding-bottom: 1rem;
  }

  .hotel-main,
  .hotel-dashboard.sidebar-collapsed .hotel-main {
    margin-left: 0;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar {
    width: 100%;
    padding-top: 2rem;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-brand {
    padding: 0 1.5rem 1.75rem;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-avatar {
    margin: 0 0 1rem;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle {
    width: 100%;
    height: auto;
    border-radius: 999px;
    padding: 0.4rem 0.75rem;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle span,
  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-section-title,
  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-link-label {
    display: inline;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-link {
    display: block;
    padding: 1rem 1.5rem;
    text-align: left;
  }

  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-link i {
    margin-right: 0.5rem !important;
  }

  .hotel-main-navbar .container-fluid {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  .hotel-main-content {
    padding: 1.25rem;
  }

  .hotel-section-shell {
    padding: 1.25rem;
  }

  .hotel-tools-reserver-wrap {
    max-width: 100%;
  }

  .hotel-tools-actions-grid {
    flex-direction: column;
  }

  .hotel-overview-shell .hotel-section-header {
    grid-template-columns: 1fr;
  }

  .hotel-overview-stats {
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  }

  .hotel-overview-title {
    font-size: 1.2rem;
  }


  .hotel-tools-title {
    font-size: 1.2rem;
  }

  .hotel-tools-subtitle {
    font-size: 0.9rem;
  }

  .hotel-switcher-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D;;cAEY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oCAAoC,EAAE,oCAAoC;EAC1E,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;EACrC,6EAA6E;AAC/E;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,8CAA8C;EAC9C,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;EACjC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yFAAyF;EACzF,6CAA6C;EAC7C,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;;EAEE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yEAAyE;AAC3E;;AAEA;;;EAGE,uFAAuF;EACvF,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;;;IAGE,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;IAEE,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,wDAAwD;AAC1D;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0CAA0C;EAC1C,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2EAA2E;EAC3E,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;IAEE,iBAAiB;EACnB;AACF;;;AAGA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2FAA2F;EAC3F,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE;IACE,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;;IAEE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mFAAmF;EACnF,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yEAAyE;AAC3E;;AAEA;;EAEE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,yEAAyE;AAC3E;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,oBAAoB;EACtB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".home-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #5b9bd5 0%, #70a8d6 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Source Sans Pro',\n    sans-serif;\n  padding-bottom: 50px;\n}\n\n.home-navbar {\n  background-color: #1a2d4a !important; /* Matching the login button color */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  padding: 15px 20px;\n}\n\n.profile-icon-button {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.12);\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n.profile-icon-button i {\n  font-size: 1.3rem;\n  line-height: 1;\n}\n\n.profile-icon-button:hover,\n.profile-icon-button:focus {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.24);\n  border-color: #ffffff;\n  transform: translateY(-1px);\n}\n\n.profile-page {\n  padding-bottom: 4rem;\n}\n\n.profile-container {\n  max-width: 980px;\n}\n\n.profile-card {\n  background: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 18px 46px rgba(26, 45, 74, 0.18);\n  overflow: hidden;\n}\n\n.profile-hero {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f7fbff, #dceeff);\n  border-bottom: 1px solid rgba(26, 45, 74, 0.08);\n}\n\n.profile-avatar {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #1a2d4a, #5b9bd5);\n  color: #ffffff;\n  font-size: 2rem;\n  font-weight: 800;\n  box-shadow: 0 14px 28px rgba(26, 45, 74, 0.22);\n}\n\n.profile-kicker {\n  color: #5b7598;\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.profile-name {\n  color: #1a2d4a;\n  font-size: 2rem;\n  font-weight: 800;\n  margin: 0;\n}\n\n.profile-email {\n  color: #5f7591;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.profile-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1px;\n  background: rgba(26, 45, 74, 0.08);\n}\n\n.profile-field {\n  background: #ffffff;\n  padding: 1.25rem 1.5rem;\n  min-width: 0;\n}\n\n.profile-field-label {\n  display: block;\n  color: #6b7f99;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  margin-bottom: 0.35rem;\n  text-transform: uppercase;\n}\n\n.profile-field-value {\n  display: block;\n  color: #1a2d4a;\n  font-size: 1rem;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.profile-language-section {\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border-top: 1px solid rgba(26, 45, 74, 0.08);\n}\n\n.profile-selection-section {\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border-top: 1px solid rgba(26, 45, 74, 0.08);\n}\n\n.profile-selection-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;\n  align-items: end;\n  gap: 0.75rem;\n}\n\n.profile-selection-status {\n  color: #5f7591;\n  font-size: 0.72rem;\n  font-weight: 800;\n  margin-bottom: 0.7rem;\n  text-align: right;\n}\n\n.profile-selection-select {\n  border: 1px solid rgba(26, 45, 74, 0.16);\n  border-radius: 8px;\n  color: #1a2d4a;\n  font-size: 0.9rem;\n  font-weight: 700;\n  min-height: 42px;\n}\n\n.profile-selection-select:focus {\n  border-color: #5b9bd5;\n  box-shadow: 0 0 0 0.2rem rgba(91, 155, 213, 0.16);\n}\n\n.profile-selection-submit {\n  border: none;\n  border-radius: 999px;\n  background: #1a2d4a;\n  font-size: 0.88rem;\n  font-weight: 800;\n  min-height: 42px;\n  min-width: 112px;\n  padding: 0.45rem 1rem;\n}\n\n.profile-selection-submit:hover:not(:disabled),\n.profile-selection-submit:focus:not(:disabled) {\n  background: #0f1a2e;\n  box-shadow: 0 10px 22px rgba(26, 45, 74, 0.18);\n}\n\n.profile-language-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.7rem;\n}\n\n.profile-language-title {\n  color: #1a2d4a;\n  font-size: 0.95rem;\n  font-weight: 800;\n  margin: 0;\n}\n\n.profile-language-current {\n  border: 1px solid rgba(91, 155, 213, 0.35);\n  border-radius: 999px;\n  color: #1a2d4a;\n  background: #f7fbff;\n  font-size: 0.72rem;\n  font-weight: 800;\n  line-height: 1;\n  padding: 0.35rem 0.55rem;\n}\n\n.profile-language-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 0 0 auto;\n}\n\n.profile-language-status {\n  color: #5f7591;\n  font-size: 0.72rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.profile-language-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.5rem;\n  max-width: 450px;\n}\n\n.profile-language-option {\n  border: 1px solid rgba(26, 45, 74, 0.12);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 42px;\n  padding: 0.45rem 0.55rem;\n  color: #1a2d4a;\n  background: #f8fafc;\n  text-align: left;\n  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.profile-language-option:hover,\n.profile-language-option:focus {\n  border-color: rgba(91, 155, 213, 0.55);\n  background: #f0f7ff;\n  box-shadow: 0 10px 22px rgba(26, 45, 74, 0.08);\n}\n\n.profile-language-option.is-selected {\n  border-color: #5b9bd5;\n  background: #eaf4ff;\n  box-shadow: inset 0 0 0 1px rgba(91, 155, 213, 0.2);\n}\n\n.profile-language-code {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: #ffffff;\n  background: #1a2d4a;\n  font-size: 0.68rem;\n  font-weight: 900;\n}\n\n.profile-language-name {\n  min-width: 0;\n  font-size: 0.82rem;\n  font-weight: 800;\n  overflow-wrap: anywhere;\n}\n\n.manual-page {\n  padding-bottom: 4rem;\n}\n\n.manual-container {\n  max-width: 1080px;\n}\n\n.manual-header {\n  color: #ffffff;\n  margin: 0 auto 1.5rem;\n  max-width: 780px;\n  text-align: center;\n}\n\n.manual-kicker {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  margin-bottom: 0.45rem;\n  text-transform: uppercase;\n}\n\n.manual-header h1 {\n  font-size: 2.4rem;\n  font-weight: 850;\n  margin-bottom: 0.75rem;\n}\n\n.manual-header p {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1.05rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.manual-quickstart {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1px;\n  margin-bottom: 1.25rem;\n  overflow: hidden;\n  border-radius: 8px;\n  background: rgba(26, 45, 74, 0.16);\n  box-shadow: 0 18px 42px rgba(26, 45, 74, 0.18);\n}\n\n.manual-quickstart > div {\n  min-width: 0;\n  padding: 1.25rem;\n  background: #ffffff;\n}\n\n.manual-step-number {\n  display: block;\n  color: #5b9bd5;\n  font-size: 0.8rem;\n  font-weight: 900;\n  margin-bottom: 0.3rem;\n}\n\n.manual-quickstart strong {\n  display: block;\n  color: #1a2d4a;\n  font-size: 1.05rem;\n  margin-bottom: 0.3rem;\n}\n\n.manual-quickstart p {\n  color: #5f7591;\n  font-weight: 650;\n  margin: 0;\n}\n\n.manual-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.manual-card,\n.manual-support {\n  border: 1px solid rgba(26, 45, 74, 0.08);\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 14px 32px rgba(26, 45, 74, 0.14);\n}\n\n.manual-card {\n  padding: 1.25rem;\n}\n\n.manual-card h2,\n.manual-support h2 {\n  color: #1a2d4a;\n  font-size: 1.15rem;\n  font-weight: 850;\n  margin-bottom: 0.75rem;\n}\n\n.manual-card ul,\n.manual-support ul {\n  margin: 0;\n  padding-left: 1.2rem;\n}\n\n.manual-card li,\n.manual-support li {\n  color: #314967;\n  font-weight: 600;\n  margin-bottom: 0.55rem;\n}\n\n.manual-card li:last-child,\n.manual-support li:last-child {\n  margin-bottom: 0;\n}\n\n.manual-support {\n  display: grid;\n  grid-template-columns: 0.7fr 1.3fr;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding: 1.35rem;\n}\n\n.manual-support .manual-kicker {\n  color: #5b7598;\n}\n\n.manual-table-wrap {\n  overflow-x: auto;\n}\n\n.manual-error-table {\n  width: 100%;\n  min-width: 620px;\n  border-collapse: collapse;\n}\n\n.manual-error-table th,\n.manual-error-table td {\n  border-bottom: 1px solid rgba(26, 45, 74, 0.1);\n  color: #314967;\n  font-size: 0.9rem;\n  padding: 0.7rem 0.65rem;\n  text-align: left;\n  vertical-align: top;\n}\n\n.manual-error-table th {\n  color: #1a2d4a;\n  font-size: 0.78rem;\n  font-weight: 850;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.manual-error-table tr:last-child td {\n  border-bottom: none;\n}\n\n.home-card {\n  background: white;\n  border-radius: 20px;\n  padding: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  border: none;\n  height: 100%;\n  transition: transform 0.3s ease;\n}\n\n.home-card:hover {\n  transform: translateY(-5px);\n}\n\n.square-box {\n  aspect-ratio: 1 / 1;\n  width: 100%;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.square-box-wrapper {\n  aspect-ratio: 1 / 1;\n  width: 100%;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.square-box-wrapper .card {\n  height: 100%;\n  overflow: hidden;\n}\n\n.square-box-wrapper .card-body {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  padding: 15px !important;\n}\n\n.square-box-wrapper form {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.square-box-wrapper .mb-3 {\n  margin-bottom: 0.5rem !important;\n}\n\n.square-box-wrapper .form-label {\n  font-size: 0.75rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.square-box-wrapper .btn {\n  margin-top: auto;\n}\n\n.square-box-wrapper .flex-grow-1 {\n  min-height: 0 !important;\n  overflow: hidden;\n}\n\n.user-panel-grid {\n  --user-panel-card-height: clamp(320px, 24vw, 360px);\n  align-items: stretch;\n}\n\n.user-panel-grid > [class*=\"col-\"] {\n  display: flex;\n}\n\n.user-panel-grid .square-box,\n.user-panel-grid .square-box-wrapper {\n  width: 100%;\n  height: var(--user-panel-card-height);\n  min-height: var(--user-panel-card-height);\n  aspect-ratio: auto;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.user-panel-grid .home-card {\n  width: 100%;\n  height: 100%;\n  min-height: var(--user-panel-card-height);\n  padding: 14px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.user-panel-grid .card-body {\n  min-height: 0;\n}\n\n.user-panel-grid .flex-grow-1 {\n  min-height: 0 !important;\n}\n\n.reservation-card.home-card,\n.control-card.home-card {\n  padding: 14px;\n  border-radius: 14px;\n}\n\n.reservation-card .card-body,\n.control-card .card-body {\n  padding: 0.55rem !important;\n}\n\n.reservation-card .card-title,\n.control-card .card-title {\n  margin-bottom: 0.45rem !important;\n  font-size: 0.82rem !important;\n  line-height: 1.15;\n}\n\n.reservation-card .mb-3,\n.control-card .mb-3 {\n  margin-bottom: 0.35rem !important;\n}\n\n.reservation-card .form-label,\n.control-card .form-label {\n  margin-bottom: 0.12rem !important;\n  font-size: 0.68rem !important;\n  line-height: 1.15;\n}\n\n.reservation-card .home-input,\n.control-card .home-input {\n  height: 30px;\n  min-height: 30px;\n  padding: 5px 9px;\n  border-radius: 9px;\n  font-size: 0.72rem;\n}\n\n.reservation-card .btn-home,\n.control-card .btn-home {\n  height: 31px;\n  min-height: 31px;\n  margin-top: auto !important;\n  padding: 5px 12px;\n  border-radius: 16px;\n  font-size: 0.72rem;\n}\n\n.home-title {\n  color: white;\n  font-weight: bold;\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 5px;\n  letter-spacing: -0.5px;\n}\n\n.home-subtitle {\n  color: #f0f0f0;\n  margin-bottom: 40px;\n  font-size: 1.1rem;\n}\n\n.home-input {\n  border: none;\n  background-color: #e0e0e0;\n  border-radius: 15px;\n  padding: 8px 15px;\n  font-size: 13px;\n  color: #666;\n  height: 38px;\n  transition: all 0.3s ease;\n}\n\n.form-select.home-input {\n  padding-right: 30px;\n}\n\n.home-input::placeholder {\n  color: #999;\n}\n\n.home-input:focus {\n  outline: none;\n  background-color: #d0d0d0;\n  box-shadow: 0 0 10px rgba(91, 155, 213, 0.3);\n}\n\n.btn-home {\n  background-color: #1a2d4a;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  padding: 8px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  height: 38px;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn-home:hover {\n  background-color: #0f1a2e;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(26, 45, 74, 0.3);\n  color: white;\n}\n\n.btn-home:active {\n  transform: translateY(0);\n}\n\n.card-title {\n  color: #333;\n  font-weight: bold;\n  font-size: 0.95rem !important;\n}\n\n.hotel-dashboard {\n  display: flex;\n  min-height: calc(100vh - 90px);\n  align-items: flex-start;\n}\n\n.hotel-sidebar {\n  width: 220px;\n  background: linear-gradient(180deg, rgba(236, 245, 255, 0.97), rgba(222, 237, 252, 0.95));\n  border-right: 1px solid rgba(26, 45, 74, 0.1);\n  padding: 2rem 0 2.5rem;\n  flex-shrink: 0;\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  overflow: hidden;\n  z-index: 20;\n  box-shadow: 18px 0 40px rgba(26, 45, 74, 0.08);\n  transition: width 0.25s ease, padding 0.25s ease;\n}\n\n.hotel-sidebar-brand {\n  padding: 7.25rem 1.5rem 1.75rem;\n  border-bottom: 1px solid rgba(26, 45, 74, 0.08);\n  margin-bottom: 1.5rem;\n}\n\n.hotel-sidebar-toggle {\n  width: 100%;\n  border: 1px solid rgba(26, 45, 74, 0.12);\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  margin-top: 2rem;\n  padding: 0.4rem 0.75rem;\n  color: #1a2d4a;\n  font-size: 0.78rem;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.72);\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.hotel-sidebar-toggle:hover,\n.hotel-sidebar-toggle:focus {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(26, 45, 74, 0.22);\n}\n\n.hotel-sidebar-avatar {\n  width: 64px;\n  height: 64px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n  color: #1a2d4a;\n  font-size: 1.8rem;\n}\n\n.hotel-sidebar-welcome {\n  color: #5f7591;\n  font-size: 0.95rem;\n}\n\n.hotel-sidebar-section-title {\n  background: rgba(91, 155, 213, 0.16);\n  color: #1a2d4a;\n  font-size: 0.9rem;\n  font-weight: 700;\n  padding: 0.95rem 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  border-top: 1px solid rgba(26, 45, 74, 0.05);\n  border-bottom: 1px solid rgba(26, 45, 74, 0.05);\n}\n\n.hotel-sidebar-nav {\n  padding: 0.75rem 0;\n}\n\n.hotel-sidebar-link {\n  width: 100%;\n  background: transparent;\n  border: none;\n  border-left: 4px solid transparent;\n  border-radius: 0;\n  color: #3a506d;\n  font-weight: 600;\n  padding: 1rem 1.5rem;\n  text-align: left;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.hotel-sidebar-link:hover,\n.hotel-sidebar-link:focus,\n.hotel-sidebar-link.is-active {\n  background: linear-gradient(90deg, rgba(91, 155, 213, 0.22), rgba(255, 255, 255, 0.35));\n  border-left-color: #5b9bd5;\n  color: #1a2d4a;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar {\n  width: 88px;\n  padding-top: 1.35rem;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-brand {\n  padding: 0 0.7rem 1.15rem;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-avatar {\n  margin: 0 auto 0.75rem;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle {\n  width: 44px;\n  height: 44px;\n  margin: 1rem auto 0;\n  padding: 0;\n  border-radius: 50%;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle span,\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-section-title,\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-link-label {\n  display: none;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-nav {\n  padding: 0.5rem 0;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.9rem 0.5rem;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-sidebar-link i {\n  margin-right: 0 !important;\n}\n\n@media (min-width: 992px) {\n  body.hotel-dashboard-compact-view {\n    overflow-x: hidden;\n  }\n\n  body.hotel-dashboard-compact-view .global-home-logo {\n    width: min(22.4vw, 144px);\n  }\n\n  body.hotel-dashboard-compact-view.hotel-dashboard-sidebar-collapsed .global-home-logo {\n    left: 8px;\n    width: 54px;\n  }\n\n  body.hotel-dashboard-compact-view .home-container {\n    min-width: 0;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-sidebar {\n    width: 176px;\n    padding: 1.6rem 0 2rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-sidebar-brand {\n    padding: 6rem 1.2rem 1.4rem;\n    margin-bottom: 1.2rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-sidebar-toggle {\n    margin-top: 1.6rem;\n    padding: 0.32rem 0.6rem;\n    font-size: 0.68rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-sidebar-section-title {\n    padding: 0.76rem 1.2rem;\n    font-size: 0.72rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-sidebar-nav {\n    padding: 0.6rem 0;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-sidebar-link {\n    padding: 0.8rem 1.2rem;\n    font-size: 0.8rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-main {\n    margin-left: 176px;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-dashboard.sidebar-collapsed .hotel-sidebar {\n    width: 70px;\n    padding-top: 1.08rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-dashboard.sidebar-collapsed .hotel-sidebar-brand {\n    padding: 3.25rem 0.5rem 1rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-dashboard.sidebar-collapsed .hotel-main {\n    margin-left: 70px;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-main-content {\n    padding: 1.2rem 1.6rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-section-shell {\n    border-radius: 22px;\n    padding: 1.4rem;\n  }\n\n  body.hotel-dashboard-compact-view #hotel-boxes .mb-4 {\n    margin-bottom: 1.2rem !important;\n  }\n\n  body.hotel-dashboard-compact-view #hotel-boxes h3 {\n    font-size: 1.35rem;\n  }\n\n  body.hotel-dashboard-compact-view #hotel-boxes p,\n  body.hotel-dashboard-compact-view #hotel-boxes .btn {\n    font-size: 0.8rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-box-grid-wrap {\n    --hotel-box-slot-size: 4.8rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-box-cabinet {\n    padding: 0.72rem;\n    gap: 0.6rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-box-grid {\n    gap: 0.44rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-box-slot-inner {\n    padding: 0.4rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-box-slot-label {\n    font-size: 0.72rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-box-slot-meta {\n    font-size: 0.5rem;\n  }\n\n  body.hotel-dashboard-compact-view .position-value {\n    font-size: 0.53rem;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-window {\n    width: min(860px, calc(100vw - 24px));\n    max-height: min(88vh, 760px);\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-list {\n    padding: 1rem;\n    max-height: calc(88vh - 96px);\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table-wrap {\n    overflow-x: hidden;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table {\n    width: 100%;\n    min-width: 0;\n    table-layout: fixed;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table th,\n  body.hotel-dashboard-compact-view .hotel-switcher-table td {\n    padding: 1.05rem 1rem;\n    overflow-wrap: anywhere;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table tbody td {\n    min-height: 76px;\n    vertical-align: middle;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table th:nth-child(1),\n  body.hotel-dashboard-compact-view .hotel-switcher-table td:nth-child(1) {\n    width: 34%;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table th:nth-child(2),\n  body.hotel-dashboard-compact-view .hotel-switcher-table td:nth-child(2) {\n    width: 22%;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-table th:nth-child(3),\n  body.hotel-dashboard-compact-view .hotel-switcher-table td:nth-child(3) {\n    width: 30%;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-action-col {\n    width: 14% !important;\n    min-width: 96px;\n    text-align: center;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-item-action {\n    min-width: 78px;\n    justify-content: center;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-switcher-item-name,\n  body.hotel-dashboard-compact-view .hotel-switcher-item-meta,\n  body.hotel-dashboard-compact-view .hotel-switcher-cell-muted {\n    overflow-wrap: anywhere;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window {\n    width: min(1080px, calc(100vw - 24px));\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th,\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td {\n    padding: 0.95rem 1rem;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(1),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(1) {\n    width: 24%;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(2),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(2) {\n    width: 16%;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(3),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(3) {\n    width: 20%;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(4),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(4) {\n    width: 14%;\n    min-width: 112px;\n    text-align: left;\n    white-space: nowrap;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th:nth-child(5),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(5) {\n    width: 16%;\n    min-width: 128px;\n    white-space: nowrap;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-action-col {\n    width: 10% !important;\n    min-width: 76px;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table th {\n    white-space: nowrap;\n  }\n\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(1),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(2),\n  body.hotel-dashboard-compact-view .hotel-components-window .hotel-switcher-table td:nth-child(3) {\n    overflow-wrap: anywhere;\n  }\n}\n\n.hotel-sidebar-calendar-control {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(91, 155, 213, 0.25);\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.75);\n  color: #1a2d4a;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.hotel-sidebar-calendar-control:hover,\n.hotel-sidebar-calendar-control:focus {\n  background: rgba(91, 155, 213, 0.18);\n  border-color: rgba(91, 155, 213, 0.45);\n}\n\n.availability-calendar-window {\n  width: min(780px, calc(100vw - 16px));\n  max-width: none;\n  max-height: calc(100vh - 12px);\n  display: flex;\n  flex-direction: column;\n}\n\n.availability-calendar-window .hotel-switcher-header {\n  flex: 0 0 auto;\n  padding: 0.9rem 1.45rem 0.65rem;\n}\n\n.availability-calendar-window .hotel-switcher-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 0.55rem 1.45rem 0.75rem;\n  overflow: hidden;\n}\n\n.availability-calendar-card {\n  height: 100%;\n  min-height: 0;\n  padding: 0.5rem 0.75rem 0.65rem;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  display: flex;\n  flex-direction: column;\n}\n\n.hotel-sidebar-calendar-summary {\n  display: flex;\n  align-items: baseline;\n  gap: 0.35rem;\n  margin-bottom: 0.25rem;\n  color: rgba(226, 232, 240, 0.82);\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.hotel-sidebar-calendar-summary span {\n  color: #0f766e;\n  font-size: 1.05rem;\n  line-height: 1;\n}\n\n.hotel-sidebar-calendar-summary strong {\n  color: #b45309;\n  font-size: 1.05rem;\n  line-height: 1;\n}\n\n.hotel-sidebar-calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 0.16rem;\n}\n\n.hotel-sidebar-calendar-day {\n  min-height: 50px;\n  padding: 0.16rem 0.28rem;\n  border: 1px solid rgba(20, 184, 166, 0.26);\n  background: rgba(20, 184, 166, 0.12);\n  color: rgba(226, 232, 240, 0.86);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.hotel-sidebar-calendar-weekday {\n  color: rgba(226, 232, 240, 0.72);\n  font-size: 0.62rem;\n  font-weight: 800;\n  line-height: 1;\n  text-align: center;\n}\n.calendar-day-number {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-align: center;\n  padding-bottom: 2px;\n  border-bottom: 1px solid rgba(0,0,0,.08);\n  line-height: 1;\n}\n\n.calendar-boxes {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin-top: 0.18rem;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.calendar-box {\n  border-radius: 4px;\n  padding: 1px 3px;\n  font-size: 0.52rem;\n  font-weight: 600;\n  line-height: 1.25;\n  text-align: center;\n  color: white;\n}\n\n.availability-box-filter {\n  margin: 0 0 0.35rem;\n  display: grid;\n  grid-template-columns: minmax(88px, max-content) minmax(0, 1fr) max-content;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.availability-box-filter-title {\n  color: rgba(255,255,255,0.9);\n  font-size: 0.68rem;\n  font-weight: 800;\n}\n\n.availability-box-filter-list {\n  max-height: 26px;\n  overflow-y: auto;\n  padding-right: 6px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(86px, 1fr));\n  gap: 0.1rem 0.45rem;\n}\n\n.availability-box-filter-actions {\n  display: flex;\n  gap: 0.4rem;\n  flex-wrap: nowrap;\n}\n\n.availability-box-filter-actions .btn {\n  padding: 0.14rem 0.6rem;\n  font-size: 0.68rem;\n  line-height: 1.2;\n}\n\n@media (max-width: 720px) {\n  .availability-calendar-window .hotel-switcher-header {\n    padding: 1rem 1rem 0.75rem;\n  }\n\n  .availability-calendar-window .hotel-switcher-list {\n    padding: 0.75rem 1rem 0.9rem;\n  }\n\n  .availability-box-filter {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n\n  .availability-box-filter-actions {\n    justify-content: flex-start;\n  }\n\n  .hotel-sidebar-calendar-day {\n    min-height: 46px;\n    padding-inline: 0.24rem;\n  }\n}\n\n.calendar-box.available {\n  background: #22c55e;\n}\n\n.calendar-box.reserved {\n  background: #ef4444;\n}\n\n.calendar-box.occupied {\n  background: #f59e0b;\n}\n\n.calendar-box.offline {\n  background: #64748b;\n}\n\n.hotel-sidebar-calendar-day span {\n  font-size: 0.95rem;\n}\n\n.hotel-sidebar-calendar-day small {\n  color: #64748b;\n  font-size: 0.68rem;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  white-space: nowrap;\n}\n\n.calendar-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.08rem;\n}\n\n.calendar-count b {\n  color: #475569;\n  font-size: 0.54rem;\n}\n\n.hotel-sidebar-calendar-day.has-availability {\n  background: rgba(20, 184, 166, 0.15);\n  border-color: rgba(20, 184, 166, 0.28);\n}\n\n.hotel-sidebar-calendar-day.has-availability small {\n  color: #0f766e;\n}\n\n.calendar-count.available {\n  color: #0f766e;\n}\n\n.calendar-count.reserved {\n  color: #b45309;\n}\n\n.hotel-sidebar-calendar-day.has-reservations {\n  border-color: rgba(245, 158, 11, 0.32);\n}\n\n.hotel-sidebar-calendar-day.is-full {\n  background: rgba(148, 163, 184, 0.12);\n  color: #64748b;\n}\n\n.hotel-sidebar-calendar-day.is-all-reserved {\n  background: rgba(245, 158, 11, 0.2);\n  border-color: rgba(245, 158, 11, 0.42);\n}\n\n.hotel-sidebar-calendar-day.is-muted {\n  opacity: 0.42;\n}\n\n.hotel-sidebar-calendar-day.is-today {\n  box-shadow: 0 0 0 2px rgba(91, 155, 213, 0.38);\n}\n\n.hotel-sidebar-calendar-legend {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.4rem;\n  margin-top: 0.45rem;\n  color: rgba(226, 232, 240, 0.72);\n  font-size: 0.58rem;\n  font-weight: 700;\n}\n\n.hotel-sidebar-calendar-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n/* Mini hotel map (in hotel overview) */\n.mini-hotel-map-wrap {\n  width: 100%;\n  height: 100%;\n  min-height: 132px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 15px;\n}\n\n.mini-hotel-map-wrap .leaflet-container {\n  border-radius: 15px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.10);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.mini-hotel-map-empty {\n  height: 100%;\n  min-height: 132px;\n  border-radius: 15px;\n  border: 1px dashed rgba(255, 255, 255, 0.22);\n  background: rgba(255, 255, 255, 0.04);\n  color: rgba(226, 232, 240, 0.72);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 991.98px) {\n  .mini-hotel-map-wrap,\n  .mini-hotel-map-empty {\n    min-height: 150px;\n  }\n}\n\n\n/* Day view (Google Calendar-like) */\n.day-view-grid { \n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.availability-day-view {\n  flex: 1 1 auto;\n  min-height: 42px;\n  max-height: 82px;\n  margin-top: 0.4rem;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.day-view-header-row {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 6px;\n  color: rgba(226, 232, 240, 0.78);\n  font-size: 0.62rem;\n  font-weight: 800;\n  padding: 0 2px;\n}\n\n.day-view-row {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 6px;\n  align-items: center;\n  padding: 2px 5px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.day-view-row.is-available {\n  border-color: rgba(20, 184, 166, 0.28);\n}\n\n.day-view-row.is-reserved {\n  border-color: rgba(245, 158, 11, 0.32);\n}\n\n.day-view-time-col {\n  color: rgba(226, 232, 240, 0.82);\n  font-size: 0.6rem;\n  font-weight: 900;\n  white-space: nowrap;\n}\n\n.day-view-box-col {\n  min-height: 20px;\n}\n\n.day-view-slot-boxes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.day-view-box {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 999px;\n  font-size: 0.56rem;\n  font-weight: 800;\n  color: #ffffff;\n  border: 1px solid rgba(255,255,255,0.35);\n}\n\n.day-view-box.available {\n  box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.12) inset;\n}\n\n.day-view-box.reserved {\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.12) inset;\n}\n\n.day-view-empty {\n  color: rgba(226, 232, 240, 0.55);\n  font-size: 0.56rem;\n  font-weight: 800;\n}\n\n.availability-day-view-empty {\n  color: rgba(226, 232, 240, 0.7);\n  font-size: 0.62rem;\n  font-weight: 700;\n  padding: 0.25rem 0;\n}\n\n.legend-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.legend-dot.available {\n  background: #14b8a6;\n}\n\n.legend-dot.reserved {\n  background: #f59e0b;\n}\n\n.legend-dot.full {\n  background: #94a3b8;\n}\n\n.box-availability-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 30px;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n}\n\n.box-availability-pill.is-available {\n  background: rgba(20, 184, 166, 0.28);\n}\n\n.box-availability-pill.is-reserved {\n  background: rgba(245, 158, 11, 0.3);\n}\n\n.box-reservation-note,\n.box-upcoming-reservations {\n  padding: 0.85rem;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(226, 232, 240, 0.86);\n  font-size: 0.84rem;\n}\n\n.box-upcoming-reservation-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 0.75rem;\n  padding: 0.42rem 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(226, 232, 240, 0.86);\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.box-upcoming-reservation-row:first-of-type {\n  border-top: 0;\n  padding-top: 0;\n}\n\n.box-detail-window {\n  width: min(860px, calc(100vw - 2rem));\n  max-width: 100%;\n  max-height: calc(100vh - 2rem);\n  display: flex;\n  flex-direction: column;\n  border-radius: 18px;\n}\n\n.box-detail-window .hotel-switcher-header {\n  flex: 0 0 auto;\n}\n\n.box-detail-window .hotel-switcher-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  padding: 1rem 1.25rem 1.25rem;\n}\n\n.box-detail-window .mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.box-detail-window .pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.box-detail-window h4 {\n  font-size: 1rem;\n}\n\n.box-detail-calendar-card {\n  padding: 0.75rem;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.box-detail-calendar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.8rem;\n}\n\n.box-detail-calendar-title {\n  color: #f8fafc;\n  font-size: 1rem;\n  font-weight: 900;\n}\n\n.box-detail-calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 0.22rem;\n}\n\n.box-detail-calendar-day {\n  min-height: 54px;\n  padding: 0.32rem 0.2rem;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  background: rgba(148, 163, 184, 0.12);\n  color: rgba(226, 232, 240, 0.8);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.15rem;\n  touch-action: none;\n  user-select: none;\n}\n\n.box-detail-calendar-day span {\n  font-size: 0.86rem;\n  line-height: 1;\n  font-weight: 900;\n}\n\n.box-detail-calendar-day small {\n  font-size: 0.55rem;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.box-detail-calendar-day.is-available {\n  background: rgba(20, 184, 166, 0.2);\n  border-color: rgba(20, 184, 166, 0.36);\n  color: #ccfbf1;\n}\n\n.box-detail-calendar-day.is-reserved {\n  background: rgba(245, 158, 11, 0.22);\n  border-color: rgba(245, 158, 11, 0.42);\n  color: #fef3c7;\n}\n\n.box-detail-calendar-day.is-muted {\n  opacity: 0.42;\n}\n\n.box-detail-calendar-day.is-today {\n  box-shadow: 0 0 0 2px rgba(91, 155, 213, 0.44);\n}\n\n.box-detail-calendar-day.is-selected-for-reservation {\n  background: rgba(91, 155, 213, 0.34);\n  border-color: rgba(191, 219, 254, 0.78);\n  color: #eff6ff;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);\n}\n\n.box-detail-calendar-day.is-dragging-selection {\n  transform: translateY(-1px);\n}\n\n.box-detail-reserver .home-card {\n  min-height: auto;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.box-detail-reserver .card-body {\n  padding: 0.75rem !important;\n}\n\n.box-detail-reserver .card-title,\n.box-detail-reserver .form-label {\n  color: #ffffff;\n}\n\n.box-detail-reserver .card-title {\n  margin-bottom: 0.6rem !important;\n  font-size: 0.86rem !important;\n}\n\n.box-detail-reserver .mb-3 {\n  margin-bottom: 0.45rem !important;\n}\n\n.box-detail-reserver .form-label {\n  margin-bottom: 0.12rem !important;\n  font-size: 0.68rem;\n}\n\n.box-detail-reserver .home-input {\n  height: 31px;\n  min-height: 31px;\n  padding: 5px 9px;\n  border-radius: 9px;\n  font-size: 0.74rem;\n}\n\n.box-detail-reserver .home-input[readonly] {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  cursor: default;\n}\n\n.box-detail-reserver .btn-home {\n  height: 32px;\n  min-height: 32px;\n  margin-top: 0.25rem !important;\n  padding: 5px 12px;\n  border-radius: 16px;\n  font-size: 0.74rem;\n}\n\n@media (max-width: 700px), (max-height: 760px) {\n  .box-detail-backdrop {\n    padding: 0.5rem;\n  }\n\n  .box-detail-window {\n    width: 100%;\n    max-height: calc(100vh - 1rem);\n    border-radius: 14px;\n  }\n\n  .box-detail-window .hotel-switcher-header {\n    padding: 0.85rem 1rem 0.65rem;\n  }\n\n  .box-detail-window .hotel-switcher-list {\n    padding: 0.75rem 1rem 1rem;\n  }\n\n  .box-detail-calendar-card {\n    padding: 0.6rem;\n  }\n\n  .box-detail-calendar-header {\n    margin-bottom: 0.55rem;\n  }\n\n  .box-detail-calendar-day {\n    min-height: 46px;\n    padding: 0.24rem 0.14rem;\n  }\n\n  .box-detail-calendar-day span {\n    font-size: 0.78rem;\n  }\n\n  .box-detail-calendar-day small {\n    font-size: 0.48rem;\n  }\n}\n\n.hotel-main {\n  flex: 1;\n  min-width: 0;\n  min-height: 100vh;\n  margin-left: 220px;\n  transition: margin-left 0.25s ease;\n}\n\n.hotel-dashboard.sidebar-collapsed .hotel-main {\n  margin-left: 88px;\n}\n\n.hotel-main-navbar {\n  margin-bottom: 0;\n}\n\n.hotel-main-content {\n  padding: 2rem;\n}\n\n.hotel-section-shell {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 28px;\n  padding: 1.75rem;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);\n}\n\n.hotel-overview-shell {\n  --hotel-overview-gap: 1rem;\n  padding: var(--hotel-overview-gap);\n}\n\n.hotel-overview-title {\n  font-size: 1.35rem;\n  line-height: 1.1;\n}\n\n.hotel-overview-shell .hotel-section-header {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(240px, 300px);\n  align-items: stretch;\n  gap: var(--hotel-overview-gap);\n  justify-content: stretch;\n  margin-bottom: var(--hotel-overview-gap);\n}\n\n.hotel-overview-shell .text-white-50 {\n  font-size: 0.9rem;\n}\n\n.hotel-overview-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--hotel-overview-gap);\n  margin: 0;\n}\n\n.hotel-overview-map,\n.hotel-overview-stat {\n  min-width: 0;\n}\n\n.hotel-overview-map {\n  min-height: 132px;\n}\n\n.hotel-section-header,\n.hotel-section-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.hotel-tools-shell {\n  padding: 0.65rem 1.75rem 0.75rem;\n}\n\n.hotel-tools-shell .hotel-section-title-row {\n  margin-bottom: 0.35rem;\n}\n\n.hotel-tools-title { \n  font-size: 1.2rem;\n  line-height: 1.1;\n  font-weight: 700;\n}\n\n.hotel-tools-subtitle {\n  font-size: 0.9rem;\n  line-height: 1.2;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.hotel-tools-shell .row.g-4.mb-5 {\n  margin-bottom: 0 !important;\n}\n\n.hotel-tools-shell .row.g-4 {\n  --bs-gutter-x: 0.5rem;\n  --bs-gutter-y: 0.5rem;\n}\n\n.hotel-tools-shell .home-card {\n  padding: 20px;\n  border-radius: 20px;\n}\n\n.hotel-tools-shell .card-body {\n  padding: 1.5rem !important;\n}\n\n.hotel-map-tooltip.leaflet-tooltip {\n  background: rgba(26, 45, 74, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 12px;\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.24);\n  color: #fff;\n  padding: 0;\n}\n\n.hotel-map-tooltip.leaflet-tooltip-top:before {\n  border-top-color: rgba(26, 45, 74, 0.96);\n}\n\n.hotel-map-tooltip-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 180px;\n  padding: 0.75rem 0.9rem;\n}\n\n.hotel-map-tooltip-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.hotel-map-tooltip-address {\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.hotel-tools-shell .card-title {\n  margin-bottom: 0.15rem !important;\n  font-size: 0.82rem;\n}\n\n.hotel-tools-shell p {\n  margin-bottom: 0.15rem !important;\n  font-size: 0.7rem;\n}\n\n.hotel-tools-shell .badge {\n  padding: 0.25rem 0.4rem !important;\n  font-size: 0.64rem;\n}\n\n.hotel-tools-shell .home-input {\n  height: 34px;\n  padding: 6px 10px;\n  font-size: 0.76rem;\n  border-radius: 10px;\n}\n\n.hotel-tools-shell .btn-home,\n.hotel-tools-shell .btn.btn-home {\n  height: 34px;\n  padding: 6px 14px;\n  font-size: 0.76rem;\n}\n\n.hotel-tools-shell .form-label {\n  margin-bottom: 0.1rem !important;\n  font-size: 0.66rem;\n}\n\n.hotel-tools-shell .mb-3 {\n  margin-bottom: 0.35rem !important;\n}\n\n.hotel-tools-shell .mt-2 {\n  margin-top: 0.2rem !important;\n}\n\n.hotel-tools-shell .table-responsive {\n  max-height: 110px !important;\n}\n\n.hotel-tools-shell .table {\n  font-size: 0.66rem;\n}\n\n.hotel-tools-shell .table th,\n.hotel-tools-shell .table td {\n  padding: 0.28rem 0.3rem;\n}\n\n.hotel-tools-shell .box-detail-card {\n  margin-top: 0.35rem !important;\n}\n\n.hotel-tools-shell .box-detail-card .card-header {\n  padding-top: 0.05rem !important;\n  padding-bottom: 0.05rem !important;\n}\n\n.hotel-tools-shell .box-detail-card .list-group-item {\n  padding-top: 0.15rem !important;\n  padding-bottom: 0.15rem !important;\n  font-size: 0.64rem;\n}\n\n.hotel-tools-reserver-wrap {\n  max-width: 380px;\n}\n\n.hotel-tools-actions-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.hotel-info-badge {\n  background: #ffffff;\n  border-radius: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  color: #334155;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 104px;\n  overflow: hidden;\n}\n\n.hotel-info-badge > .d-flex {\n  min-width: 0;\n  width: 100%;\n}\n\n.hotel-info-badge .text-start {\n  min-width: 0;\n}\n\n.hotel-info-badge .text-nowrap {\n  white-space: normal !important;\n}\n\n.weather-badge {\n  max-width: none;\n}\n\n.capacity-badge {\n  min-width: 0;\n}\n\n.hotel-box-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(5px);\n  border-radius: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 25px;\n  transition: transform 0.3s ease, background 0.3s ease;\n}\n\n.hotel-component-card {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(5px);\n  border-radius: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 1.35rem;\n  transition: transform 0.3s ease, background 0.3s ease;\n}\n\n.hotel-component-card:hover {\n  transform: translateY(-4px);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.hotel-component-title {\n  color: #f8fafc;\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.hotel-component-meta {\n  display: grid;\n  gap: 0.7rem;\n}\n\n.hotel-component-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 1rem;\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 0.92rem;\n}\n\n.hotel-component-label {\n  color: rgba(153, 246, 228, 0.86);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.hotel-box-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: rgba(45, 212, 191, 0.18);\n  color: #99f6e4;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  padding: 0.35rem 0.75rem;\n  text-transform: uppercase;\n}\n\n.hotel-box-grid-wrap {\n  padding: 0rem;\n  border-radius: 1px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.05);\n  overflow: auto;\n  --hotel-box-slot-size: 6rem;\n}\n\n.hotel-box-cabinets {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 360px), 1fr));\n  gap: 1rem;\n}\n\n.hotel-box-cabinet {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  min-width: 0;\n  padding: 0.9rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.16);\n}\n\n.hotel-box-cabinet-title {\n  color: rgba(248, 250, 252, 0.9);\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.hotel-box-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--hotel-box-grid-columns, 4), var(--hotel-box-slot-size));\n  grid-auto-rows: var(--hotel-box-slot-size);\n  gap: 0.55rem;\n  width: max-content;\n  max-width: none;\n  min-width: 0;\n}\n\n.hotel-box-slot {\n  width: var(--hotel-box-slot-size);\n  height: var(--hotel-box-slot-size);\n  aspect-ratio: 1 / 1;\n  min-height: 0;\n}\n\n.hotel-box-slot-inner {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0.5rem;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(30, 41, 59, 0.18);\n  border-radius: 8px;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);\n}\n\n.hotel-box-slot-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  color: #0f172a;\n  font-size: 0.9rem;\n  font-weight: 800;\n  line-height: 1.2;\n  min-width: 0;\n}\n\n.hotel-box-slot-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.16rem;\n  color: #475569;\n  font-size: 0.62rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.1;\n  min-width: 0;\n}\n\n.hotel-box-slot-meta span,\n.position-value {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hotel-box-position-info {\n  width: 100%;\n  margin-top: 0.25rem;\n  padding-top: 0.25rem;\n  border-top: 1px solid rgba(71, 85, 105, 0.2);\n}\n\n.position-value {\n  color: #1e293b;\n  font-size: 0.66rem;\n  font-weight: 800;\n}\n\n.hotel-box-slot.is-available .hotel-box-slot-inner {\n  background: linear-gradient(180deg, #ecfdf5, #d1fae5);\n  border-color: rgba(5, 150, 105, 0.45);\n}\n\n.hotel-box-slot.is-reserved .hotel-box-slot-inner {\n  background: linear-gradient(180deg, #eff6ff, #dbeafe);\n  border-color: rgba(37, 99, 235, 0.45);\n}\n\n.hotel-box-slot.is-occupied .hotel-box-slot-inner {\n  background: linear-gradient(180deg, #fff7ed, #fed7aa);\n  border-color: rgba(234, 88, 12, 0.45);\n}\n\n.hotel-box-slot.is-offline .hotel-box-slot-inner {\n  background: linear-gradient(180deg, #f8fafc, #e2e8f0);\n  border-color: rgba(71, 85, 105, 0.5);\n}\n\n.hotel-box-slot.is-unknown .hotel-box-slot-inner {\n  background: rgba(255, 255, 255, 0.92);\n  border-color: rgba(30, 41, 59, 0.3);\n}\n\n@media (max-width: 576px) {\n  .home-navbar .container-fluid {\n    justify-content: space-between !important;\n    gap: 0.75rem;\n  }\n\n  .home-navbar .navbar-brand {\n    font-size: 1.05rem !important;\n  }\n\n  .home-navbar .position-absolute.end-0 {\n    position: static !important;\n  }\n\n  .home-navbar .btn-outline-light {\n    padding-left: 0.85rem !important;\n    padding-right: 0.85rem !important;\n  }\n\n  .manual-navbar-actions,\n  .profile-navbar-actions {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n\n  .manual-header {\n    text-align: left;\n  }\n\n  .manual-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .manual-quickstart,\n  .manual-grid,\n  .manual-support {\n    grid-template-columns: 1fr;\n  }\n\n  .manual-card,\n  .manual-support {\n    padding: 1rem;\n  }\n\n  .profile-icon-button {\n    width: 38px;\n    height: 38px;\n  }\n\n  .profile-hero {\n    align-items: flex-start;\n    flex-direction: column;\n    padding: 1.5rem;\n  }\n\n  .profile-avatar {\n    width: 78px;\n    height: 78px;\n    font-size: 1.65rem;\n  }\n\n  .profile-name {\n    font-size: 1.45rem;\n  }\n\n  .profile-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-field {\n    padding: 1rem 1.25rem;\n  }\n\n  .profile-selection-section,\n  .profile-language-section {\n    padding: 1rem;\n  }\n\n  .profile-selection-form {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-selection-submit {\n    width: 100%;\n  }\n\n  .profile-language-header {\n    align-items: flex-start;\n  }\n\n  .profile-language-options {\n    grid-template-columns: 1fr;\n  }\n\n  .hotel-box-grid-wrap {\n    padding: 0.75rem;\n    --hotel-box-slot-size: 5.5rem;\n  }\n\n  .hotel-box-cabinets {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .hotel-box-cabinet {\n    padding: 0.75rem;\n  }\n\n  .hotel-box-cabinet-title {\n    font-size: 0.72rem;\n  }\n\n  .hotel-box-grid {\n    width: max-content;\n    max-width: none;\n    min-width: 0;\n    gap: 0.45rem;\n  }\n\n  .hotel-box-slot {\n    width: var(--hotel-box-slot-size);\n    height: var(--hotel-box-slot-size);\n  }\n\n  .hotel-box-slot-inner {\n    padding: 0.45rem;\n  }\n\n  .hotel-box-slot-label {\n    font-size: 0.82rem;\n  }\n\n  .hotel-box-slot-meta {\n    font-size: 0.56rem;\n  }\n\n  .position-value {\n    font-size: 0.58rem;\n  }\n}\n\n.hotel-switcher-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(8px);\n}\n\n.hotel-switcher-window {\n  width: min(680px, 100%);\n  max-height: min(80vh, 720px);\n  overflow: hidden;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: linear-gradient(180deg, rgba(14, 25, 41, 0.96), rgba(20, 37, 61, 0.93));\n  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.38);\n}\n\n.hotel-switcher-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.5rem 1.5rem 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.hotel-switcher-eyebrow {\n  color: rgba(153, 246, 228, 0.86);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  margin-bottom: 0.4rem;\n}\n\n.hotel-switcher-title {\n  color: #f8fafc;\n  font-size: 1.35rem;\n  line-height: 1.15;\n}\n\n.hotel-switcher-list {\n  padding: 1.2rem 1.5rem 1.5rem;\n  max-height: calc(92vh - 112px);\n  overflow-y: auto;\n}\n\n.hotel-switcher-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.hotel-switcher-table {\n  width: 100%;\n  min-width: 640px;\n  border-collapse: separate;\n  border-spacing: 0;\n  color: #e2e8f0;\n}\n\n.hotel-switcher-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 1rem 1.1rem;\n  background: rgba(14, 25, 41, 0.98);\n  color: rgba(226, 232, 240, 0.74);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.hotel-switcher-table tbody td {\n  padding: 1rem 1.1rem;\n  vertical-align: middle;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.hotel-switcher-table tbody tr {\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.hotel-switcher-table tbody tr:hover {\n  background: rgba(59, 130, 246, 0.12);\n}\n\n.hotel-switcher-table tbody tr.is-current {\n  background: rgba(45, 212, 191, 0.12);\n}\n\n.hotel-switcher-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.hotel-switcher-item-name {\n  color: #f8fafc;\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n}\n\n.hotel-switcher-item-meta {\n  color: rgba(226, 232, 240, 0.7);\n  font-size: 0.85rem;\n  line-height: 1.35;\n}\n\n.hotel-switcher-cell-muted {\n  color: rgba(226, 232, 240, 0.82);\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.hotel-switcher-stat {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  border-radius: 999px;\n  padding: 0.38rem 0.72rem;\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(226, 232, 240, 0.9);\n  font-size: 0.78rem;\n  line-height: 1.2;\n}\n\n.hotel-switcher-action-col {\n  width: 1%;\n  white-space: nowrap;\n}\n\n.hotel-switcher-item-action {\n  flex-shrink: 0;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  padding: 0.38rem 0.8rem;\n  background: rgba(255, 255, 255, 0.08);\n  color: #bae6fd;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.hotel-switcher-item-action:hover,\n.hotel-switcher-item-action:focus {\n  background: rgba(59, 130, 246, 0.18);\n  border-color: rgba(125, 211, 252, 0.45);\n}\n\n.hotel-switcher-item-action.is-current {\n  background: rgba(45, 212, 191, 0.16);\n  border-color: rgba(153, 246, 228, 0.3);\n  color: #ccfbf1;\n}\n\n.hotel-icon-action {\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #bae6fd;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.hotel-icon-action:hover,\n.hotel-icon-action:focus {\n  background: rgba(59, 130, 246, 0.22);\n  border-color: rgba(125, 211, 252, 0.5);\n  color: #f8fafc;\n}\n\n.hotel-icon-action:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.hotel-switcher-action-col .hotel-icon-action {\n  margin-left: 0.45rem;\n}\n\n.hotel-inline-edit-form,\n.hotel-box-edit-panel {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 0.7rem;\n  align-items: center;\n}\n\n.hotel-inline-edit-input {\n  min-width: 0;\n  width: 100%;\n  min-height: 2.35rem;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 0.48rem 0.65rem;\n  background: rgba(15, 23, 42, 0.86);\n  color: #f8fafc;\n  font-size: 0.85rem;\n  outline: none;\n}\n\n.hotel-inline-edit-input:focus {\n  border-color: rgba(125, 211, 252, 0.62);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.16);\n}\n\n.hotel-inline-edit-input.is-wide {\n  grid-column: span 2;\n}\n\n.hotel-inline-edit-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.hotel-inline-edit-message {\n  grid-column: 1 / -1;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.hotel-inline-edit-message.is-error {\n  color: #fca5a5;\n}\n\n.hotel-box-edit-panel {\n  margin-top: 1rem;\n  padding: 1rem;\n  border: 1px solid rgba(125, 211, 252, 0.24);\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.74);\n}\n\n.hotel-box-edit-panel-title {\n  color: #f8fafc;\n  font-weight: 800;\n}\n\n.hotel-switcher-empty {\n  padding: 2rem 1rem;\n  border-radius: 18px;\n  border: 1px dashed rgba(255, 255, 255, 0.16);\n  color: rgba(226, 232, 240, 0.72);\n  text-align: center;\n}\n\n@media (max-width: 991.98px) {\n  .hotel-dashboard {\n    flex-direction: column;\n  }\n\n  .hotel-sidebar {\n    position: static;\n    left: auto;\n    top: auto;\n    bottom: auto;\n    height: auto;\n    overflow: visible;\n    width: 100%;\n    padding-bottom: 1rem;\n  }\n\n  .hotel-main,\n  .hotel-dashboard.sidebar-collapsed .hotel-main {\n    margin-left: 0;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar {\n    width: 100%;\n    padding-top: 2rem;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-brand {\n    padding: 0 1.5rem 1.75rem;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-avatar {\n    margin: 0 0 1rem;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle {\n    width: 100%;\n    height: auto;\n    border-radius: 999px;\n    padding: 0.4rem 0.75rem;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-toggle span,\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-section-title,\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-link-label {\n    display: inline;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-link {\n    display: block;\n    padding: 1rem 1.5rem;\n    text-align: left;\n  }\n\n  .hotel-dashboard.sidebar-collapsed .hotel-sidebar-link i {\n    margin-right: 0.5rem !important;\n  }\n\n  .hotel-main-navbar .container-fluid {\n    padding-left: 1.25rem !important;\n    padding-right: 1.25rem !important;\n  }\n\n  .hotel-main-content {\n    padding: 1.25rem;\n  }\n\n  .hotel-section-shell {\n    padding: 1.25rem;\n  }\n\n  .hotel-tools-reserver-wrap {\n    max-width: 100%;\n  }\n\n  .hotel-tools-actions-grid {\n    flex-direction: column;\n  }\n\n  .hotel-overview-shell .hotel-section-header {\n    grid-template-columns: 1fr;\n  }\n\n  .hotel-overview-stats {\n    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  }\n\n  .hotel-overview-title {\n    font-size: 1.2rem;\n  }\n\n\n  .hotel-tools-title {\n    font-size: 1.2rem;\n  }\n\n  .hotel-tools-subtitle {\n    font-size: 0.9rem;\n  }\n\n  .hotel-switcher-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
